const NETWORK_ERROR_MESSAGE =
  "Failed to submit your Client Application due to a network error. Please check your internet connection and try again.";

const GENERIC_ERROR_MESSAGE =
  "Failed to submit your Client Application. Please try again.";

const MULTIPART_ERROR_MESSAGE = "Invalid multipart request";

const MULTIPART_GUIDANCE =
  "We couldn't upload your file. Please try again. If the problem continues, select the file again and retry.";

const SIZE_GUIDANCE =
  "Your file is too large to upload. Please select a file up to 9.5 MB and try again.";

export const getKycSubmissionErrorMessage = (error) => {
  const responseData = error?.response?.data;
  const responseMessage =
    typeof responseData?.message === "string"
      ? responseData.message
      : typeof responseData === "string"
        ? responseData
        : "";
  const message = typeof error?.message === "string" ? error.message : "";
  const status = error?.response?.status;

  if (status === 413) return SIZE_GUIDANCE;

  if (
    responseMessage === MULTIPART_ERROR_MESSAGE ||
    message === MULTIPART_ERROR_MESSAGE
  ) {
    return MULTIPART_GUIDANCE;
  }

  if (typeof responseMessage === "string" && responseMessage.trim()) {
    return responseMessage;
  }

  if (error?.isUploadError && status === 400) return MULTIPART_GUIDANCE;

  try {
    const { fieldname, filename } = JSON.parse(message);
    if (fieldname && filename) {
      return `Your uploaded file for ${fieldname}, ${filename}, is not supported. Upload a PNG, JPG/JPEG, WEBP, HEIC/HEIF, or PDF file.`;
    }
  } catch {
    // Non-upload errors are handled by the fallbacks below.
  }

  if (message === "Network Error") return NETWORK_ERROR_MESSAGE;

  return message || GENERIC_ERROR_MESSAGE;
};
